import { jsx as v } from "react/jsx-runtime";
import { SvgIcon as m } from "../SvgIcon.js";
const l = (e) => /* @__PURE__ */ v(m, { ...e, children: /* @__PURE__ */ v(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9962 3v4.77701h-4.777V3h4.777Zm-3.4109 3.41085H15.63v-2.0447h-2.0447v2.0447Zm-2.7322-.33462V4.71007H5.05378v3.52848L3.9681 7.16191l-.96807.95902 2.7323 2.73227 2.73231-2.73227-.96807-.96807-1.07664 1.08569V6.07623h4.43317Zm1.0224 5.45537 2.7323-2.72323 2.7323 2.72323-.9681.9681-1.0857-1.0766v3.5284H9.48695v-1.3661h4.44225v-2.1623l-1.0857 1.0766-.968-.9681Zm-3.75466.3431V16.6518H3.34383V11.8747h4.77701Zm-3.41086 3.4109h2.04471v-2.0447H4.70998v2.0447Z"
  }
) });
export {
  l as CustomReplace
};
//# sourceMappingURL=CustomReplace.js.map
